import { UIFlightData } from "@flights/types";
import useCreateUrl from "hooks/useCreateUrl";
import { useCallback } from "react";
import { useHistory, useParams } from "react-router-dom";
import useOfferCartOrderData from "hooks/useOfferCartOrderData";
import useGetSearchResultsBound from "hooks/useGetSearchResultsBound";
import flights_apex_web_cfar_on_sr_fd from "utils/experiments/apex/flights_apex_web_cfar_on_sr_fd";

export default function useGoToFlightDetails() {
  const params = useParams<{ airports: string; outboundToken: string }>();
  const { createUrl } = useCreateUrl();
  const history = useHistory();
  const offerCartOrderData = useOfferCartOrderData();
  const bound = useGetSearchResultsBound();

  return useCallback(
    (flightToken: string, baseOffer: UIFlightData, brandedFareIndex?: number) => {
      const locationParams = location.search;
      const urlParams = new URLSearchParams(locationParams);

      if (!!baseOffer.ancillaries?.cancelForAnyReason) {
        flights_apex_web_cfar_on_sr_fd.goals.action_click_with_cfar_badge_on_sr();
      }

      urlParams.set("baseOfferToken", baseOffer.token);

      if (brandedFareIndex !== undefined && Number.isInteger(brandedFareIndex)) {
        urlParams.set("brandedFareIndex", brandedFareIndex.toString());
      }

      offerCartOrderData.set(flightToken, { offer: flightToken, parentOfferToken: baseOffer.token });

      let url = `/flights/${params.airports}/${flightToken}/?${urlParams}`;

      /* start - flights_split_bounds_us */
      // Check if we are on a Split Bounds page.
      if (bound && params.outboundToken) {
        url = `/flights/${params.airports}/inbound/${params.outboundToken}/${flightToken}/?${urlParams}`;
      }
      /* end - flights_split_bounds_us */

      history.push(createUrl(url));
    },
    [offerCartOrderData, params.airports, params.outboundToken, bound, history, createUrl]
  );
}
